import { LegalLayout, Section } from "@/components/LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout title="Privacy Policy" updated="June 2026">
      <p>
        This Privacy Policy explains how Carrot ("Carrot", "we", "us") collects, uses, and protects your
        information when you use our web application. By using Carrot, you agree to this policy. Carrot is
        currently offered as a Beta service.
      </p>

      <Section heading="Information we collect">
        <p>When you sign in with Google, we receive and store your basic Google profile information:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Your name and email address</li>
          <li>Your Google profile picture (avatar)</li>
        </ul>
        <p>
          We also store the content you create in Carrot — your tasks ("Roots"), notes, categories,
          priorities, snooze times, workspaces, assignments, and any feedback you submit.
        </p>
      </Section>

      <Section heading="How we use your information">
        <ul className="list-disc pl-6 space-y-1">
          <li>To authenticate you and keep you signed in (via a secure session cookie)</li>
          <li>To store and display your tasks and workspaces</li>
          <li>To generate Root codes from your task descriptions using an AI service</li>
          <li>To operate, maintain, and improve the service</li>
        </ul>
        <p>We do not sell your personal information, and we do not use it for advertising.</p>
      </Section>

      <Section heading="Google user data">
        <p>
          Carrot's use of information received from Google APIs adheres to the{" "}
          <a href="https://developers.google.com/terms/api-services-user-data-policy" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">
            Google API Services User Data Policy
          </a>
          , including the Limited Use requirements. We only request the minimum scopes needed to sign you
          in and identify your account (your name, email, and profile picture).
        </p>
      </Section>

      <Section heading="Third-party services">
        <p>We rely on a small number of trusted providers to run Carrot:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li><strong>Google OAuth</strong> — to sign you in securely</li>
          <li><strong>MongoDB</strong> — to store your account and task data</li>
          <li><strong>AI language model provider</strong> — to turn your task descriptions into Root codes</li>
        </ul>
        <p>These providers process data only to deliver their part of the service.</p>
      </Section>

      <Section heading="Cookies">
        <p>
          We use a single, essential session cookie to keep you logged in. We do not use tracking or
          advertising cookies.
        </p>
      </Section>

      <Section heading="Data retention & deletion">
        <p>
          We keep your data for as long as your account is active. You can delete your data at any time by
          contacting us at the email below, and we will remove your account and associated tasks.
        </p>
      </Section>

      <Section heading="Security">
        <p>
          We take reasonable measures to protect your information, including encrypted connections (HTTPS)
          and httpOnly session cookies. No method of transmission or storage is 100% secure, but we work to
          keep your data safe.
        </p>
      </Section>

      <Section heading="Changes to this policy">
        <p>
          We may update this policy from time to time. Material changes will be reflected by updating the
          "Last updated" date above.
        </p>
      </Section>
    </LegalLayout>
  );
}
